var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M26.751 8.007c1.364 1.365 3.364 1.708 5.046 1.032l3.613 3.611c.737.74.738 1.938-.004 2.68L15.319 35.405c-.743.739-1.94.737-2.681 0l-3.606-3.612c.672-1.684.33-3.682-1.032-5.047-1.367-1.365-3.364-1.707-5.047-1.032l-2.359-2.36c-.74-.737-.742-1.938 0-2.68L20.678.596c.739-.74 1.936-.741 2.679.002l2.361 2.361c-.677 1.683-.331 3.681 1.033 5.048z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1931",
    d: "M5.42 18.527l-2.149 2.148c-.739.739-.741 1.939-.003 2.68l.542.541c1.896-.505 3.999-.018 5.482 1.468 1.488 1.486 1.971 3.589 1.467 5.481l1.878 1.883c.741.739 1.941.739 2.682-.002l2.189-2.187L5.42 18.527zm13.521 10.58l10.158-10.152L17.008 6.943 6.854 17.095l12.087 12.012zm1.99-13.993c2.245 2.228 2.745 5.356 1.121 6.989-1.627 1.635-4.762 1.151-7.001-1.075-2.239-2.228-2.738-5.358-1.114-6.991 1.625-1.63 4.755-1.15 6.994 1.077zm11.8-2.464l-1.881-1.881c-1.895.503-3.998.021-5.483-1.468-1.488-1.484-1.976-3.591-1.47-5.484l-.541-.546c-.74-.735-1.94-.735-2.678.003L18.442 5.51l12.092 12.011 2.196-2.195c.74-.737.74-1.936.001-2.676z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.1e415a5033dc9d8d3d1e2f75ff9cc1ee.svg";
export { ForwardRef as ReactComponent };